// @flow
export type OMNISEARCH_ROUTE_RESULT_TYPE = {
  result_type: 'route',
  id: string,
  name: string,
  object_id: string,
  school: string,
  short_name: string,
  text: string,
};
export const OMNISEARCH_ROUTE_TYPE = 'route';

export type OMNISEARCH_ROUTE_STOP_RESULT_TYPE = {
  id: string,
  name: string,
  school: string,
  short_name: string,
  text: string,
};
export const OMNISEARCH_ROUTE_STOP_TYPE = 'route_stop';

export type OMNISEARCH_STUDENT_RESULT_TYPE = {
  result_type: 'student_profile',
  id: string,
  code: string,
  first_name: string,
  last_name: string,
  full_name: string,
  profile_picture: string,
  object_id: string,
  school: string,
  user_id: string,
  text: string,
};
export const OMNISEARCH_STUDENT_TYPE = 'student_profile';

export type OMNISEARCH_MONITOR_RESULT_TYPE = {
  result_type: 'monitor_profile',
  id: string,
  first_name: string,
  last_name: string,
  full_name: string,
  profile_picture: string,
  object_id: string,
  school: string,
  user_id: string,
  text: string,
};
export const OMNISEARCH_MONITOR_TYPE = 'monitor_profile';

export type OMNISEARCH_PARENT_RESULT_TYPE = {
  result_type: 'parent_profile',
  id: string,
  first_name: string,
  last_name: string,
  full_name: string,
  profile_picture: string,
  object_id: string,
  school: string,
  user_id: string,
  text: string,
};
export const OMNISEARCH_PARENT_TYPE = 'parent_profile';

export type OMNISEARCH_DRIVER_RESULT_TYPE = {
  result_type: 'driver_profile',
  id: string,
  first_name: string,
  last_name: string,
  full_name: string,
  profile_picture: string,
  object_id: string,
  school: string,
  user_id: string,
  text: string,
};
export const OMNISEARCH_DRIVER_TYPE = 'driver_profile';

export type OMNISEARCH_BUS_RESULT_TYPE = {
  result_type: 'bus',
  id: string,
  name: string,
  short_name: string,
  plates: string,
  object_id: string,
  school: string,
  text: string,
};
export const OMNISEARCH_BUS_TYPE = 'bus';

export type OMNISEARCH_RESULT_TYPE =
  | OMNISEARCH_ROUTE_RESULT_TYPE
  | OMNISEARCH_STUDENT_RESULT_TYPE
  | OMNISEARCH_ROUTE_RESULT_TYPE
  | OMNISEARCH_MONITOR_RESULT_TYPE
  | OMNISEARCH_DRIVER_RESULT_TYPE
  | OMNISEARCH_BUS_RESULT_TYPE;

export type OMNISEARCH_RESPONSE_TYPE = {
  results: Array<OMNISEARCH_RESULT_TYPE>,
};



// WEBPACK FOOTER //
// ./src/scripts/types/omnisearch.js